<div class="content-wrapper">
  <app-loading-panel [showLoading]="loading" overlay="true" />
  <app-profile-title [title]="
      (editMode()
        ? 'public.profile.address.edit'
        : 'public.profile.address.add'
      ) | translate
    " [backTo]="'profile'" />
  <div class="content p-3">
    <form class="mx-3" [formGroup]="profileForm" (submit)="handleSubmit($event)">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-input-text class="mb-4" inputId="streetAddress" autocomplete="street-address" maxLength="200"
              [label]="'public.checkout.streetAddress' | translate" [required]="true"
              [control]="getControl('streetAddress')"
              [isInvalid]="getControl('streetAddress').invalid && (getControl('streetAddress').touched || getControl('streetAddress').dirty)"
              [errorText]="
                getControl('streetAddress').hasError('required') ? ('public.checkout.errors.fieldRequired' | translate) :
                getControl('streetAddress').hasError('minlength') ? ('public.checkout.errors.minLength' | translate) :
                getControl('streetAddress').hasError('maxlength') ? ('public.checkout.errors.maxLength' | translate) : ''
              " />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-input-text class="mb-4" inputId="city" autocomplete="address-level2" maxLength="100"
              [label]="'public.checkout.town' | translate" [required]="true" [control]="getControl('city')"
              [isInvalid]="getControl('city').invalid && (getControl('city').touched || getControl('city').dirty)"
              [errorText]="
                getControl('city').hasError('required') ? ('public.checkout.errors.fieldRequired' | translate) :
                getControl('city').hasError('minlength') ? ('public.checkout.errors.minLength' | translate) :
                getControl('city').hasError('maxlength') ? ('public.checkout.errors.maxLength' | translate) : ''
              " />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-input-text class="mb-4" inputId="postCode" autocomplete="postal-code" maxLength="20"
              [label]="'public.checkout.zip' | translate" [required]="true" [control]="getControl('postCode')"
              [isInvalid]="getControl('postCode').invalid && (getControl('postCode').touched || getControl('postCode').dirty)"
              [errorText]="
                getControl('postCode').hasError('required') ? ('public.checkout.errors.fieldRequired' | translate) :
                getControl('postCode').hasError('minlength') ? ('public.checkout.errors.minLength' | translate) :
                getControl('postCode').hasError('maxlength') ? ('public.checkout.errors.maxLength' | translate) : ''
              " />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-input-text class="mb-4" inputId="floorNumber" maxLength="20"
              [label]="'public.checkout.floor' | translate" [control]="getControl('floorNumber')" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-input-text class="mb-4" inputId="doorbell" maxLength="20"
              [label]="'public.checkout.doorbell' | translate" [control]="getControl('doorbell')" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group form-check">
            <input id="isMain" type="checkbox" class="form-check-input checkbox" [formControl]="getControl('isMain')" />
            <label class="form-check-label pl-2 mt-1" for="isMain">
              {{ 'public.profile.address.setDefault' | translate }}
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 col-md-6 mb-3">
          <span><app-button startIcon="fa-save" type="submit" class="mr-2" [customStyles]="{ 'min-width': '130px' }">{{
              'public.profile.save' | translate }}</app-button></span>
          <span class="ml-3"><app-button variant="link" (click)="handleCancel($event)">{{ 'public.dialog.cancel' |
              translate }}
            </app-button></span>
        </div>
        <div class="col-sm-6 col-md-6 text-sm-right">
          <app-button *ngIf="editMode()" startIcon="fa-trash" variant="danger" (click)="handleDelete($event)">{{
            'public.profile.address.delete' | translate }}</app-button>
        </div>
      </div>
    </form>
  </div>
</div>